<template>
    <div class="content_item"    
     v-on:click="view_article(item.id)"
     @mouseenter.stop="image_zoom_in($event)"
     @mouseleave.stop="image_zoom_out($event)"
    >
    <div class="category_pill">
        <span v-if="item.contained_youtube" class="youtube_icon"><i class="fab fa-youtube"></i></span>
        <span>{{item.category_title}}</span>
        </div>
    <div class="favorite_article" @click.stop="toggle_favorite(item.id, item.favorite)">
        <i v-if="item.favorite" class="fas fa-heart" style="color:red"></i>
        <i  v-else class="far fa-heart"></i>
    </div>
    <div class="content_thumb" :style="{ 'background-image': `url('${src + item.thumbnail}'),url('/static/images/default_thumb.png')`}" ></div>       
    
    <div class="content_title">{{item.title | truncate(50)}}</div>
    <div class="sub_text">조회수 {{item.view_count}}회 ㆍ {{item.published_at.substr(0,4)}}년{{item.published_at.substr(4,2)}}월 호</div>
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
    props:["item"],
    methods:{
        view_article(id){
            if(this.$route.name == "search"){
                window.open(`/contents/${id}`)
            }else
            this.$router.push(`/contents/${id}`)
        },
        image_zoom_in(e){    
            $(e.target).find(".content_thumb").css("background-size", "270px 155px")
            $(e.target).find(".content_title").css("text-decoration","underline")
        },
        image_zoom_out(e){
            $(e.target).find(".content_thumb").css("background-size", "240px 140px")
            $(e.target).find(".content_title").css("text-decoration","")
        },
        toggle_favorite(str, favorite){
            if(!localStorage.getItem("login")){alert("관심 등록은 로그인후에 이용이 가능합니다.")}    
            if(favorite == true){
                if(confirm("관심을 해제하시겠습니까")){
                    this.$http.post("app/toggle_favorite_article",this.qs({"id":str})).then(res=>{    
                        EventBus.$emit("favorite_article_list",str) 
                        this.$toasted.success("관심 해제 되었습니다")
                    })   
                }
            }else{
                this.$http.post("app/toggle_favorite_article",this.qs({"id":str})).then(res=>{    
                        EventBus.$emit("favorite_article_list",str)     
                        this.$toasted.success("관심 등록 되었습니다. 마이페이지에서 확인하실 수 있습니다.")    
                    })   
            }
        },
    }    
}
</script>

<style scoped lang="scss">
.content_item{
    cursor: pointer;
    width: 252px;
    height:230px;
    position: relative;
    border:1px solid #ddd;
    border-radius: 10px;
    .favorite_article{
        cursor: pointer;
        position: absolute;
        width: 20px;
        height: 20px;
        color : #333;
        font-size: 14px;
        text-align: center;
        line-height: 18px;
        border-radius: 10px;
        top : 10px;
        right: 10px;
    }
    .content_thumb{
        width: 240px;
        margin:5px;
        height: 140px;
        background-position: center;
        background-size: 240px 140px;
        transition: all 1s;
        border-radius: 10px;
    }
    .logo{
        width: 50px;
        height: 50px;
        border-radius: 30px;
        border:2px solid #fff;
        margin-top:0px; 
        float: left;
    }
    .content_title{
        float: left;
        width: 230px;
        font-size: 12px;
        margin-left: 10px;
        color:#333;
        height: 55px;
    }
    .sub_text{
        color:#606060;
        font-size: 12px;
        padding-left: 10px;
        clear:both;
    }
    .category_pill{
        position: absolute;
        bottom: 85px;  
        width: 100%;
        padding-right: 10px;
        span{
            padding: 2px 5px;
            border-radius: 20px;
            border: 1px solid #666;
            background-color: #fff;
            color: #666;
            font-size: 11px;
            float: right;
            margin-left: 5px;
        }
        .youtube_icon{
            border: 1px solid #cb3e3e;
            color: #cb3e3e;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/SPA/Main/Components/MainPublicContentsItemArticle.vue